export class AuthTimeoutError extends Error {}
